import { defineComponent } from 'vue'
import styles from './index.module.scss'

export default defineComponent({
  name: 'MkLoading',
  setup() {
    return () => (
      <div class={styles.loading}>
        <img
          src={require('./images/loading.gif')}
          alt="loading"
        />
        <div class={styles.tips}>
          正在加载中...
        </div>
      </div>
    )
  },
})
